const initialState = {
    tag: [{code: 'innovations'}],
    tags: null,
    marketFilter: null,
    results:[],
    total:0,
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setTag(state, value) {
            if (Array.isArray(state.tag) && value.code !== 'innovations') {
                let tagExist = state.tag.findIndex(tag => tag.code === value.code);
                if (tagExist !== -1) {
                    state.tag.splice(tagExist, 1);
                } else {
                    if (state.tag[1]) state.tag.splice(1, 1);
                    state.tag.push(value)
                }
            } else state.tag = [{code: 'innovations'}];
        },
        setTags(state, value) {
            state.tags = value;
        },
        setMarketFilter(state, value) {
            state.marketFilter = value;
        },
        setTotal(state, value) {
            state.total = value;
        },
        setResults(state, value) {
            state.results = value;
        },
    },
};
